// frontend/user/src/_lib/use-multi-select.ts
// 多选模式状态(BLWNx / UGuBc)。列表组件通过 registerAll 上报当前可选 id 全集,
// 头部"全选/取消全选"据此切换。退出时清空选择。
import { useCallback, useState } from 'react'

export type MultiSelect = {
  active: boolean
  ids: ReadonlySet<string>
  count: number
  allSelected: boolean
  enter: () => void
  exit: () => void
  toggle: (id: string) => void
  toggleAll: () => void
  registerAll: (ids: string[]) => void
}

export function useMultiSelect(): MultiSelect {
  const [active, setActive] = useState(false)
  const [ids, setIds] = useState<ReadonlySet<string>>(new Set())
  const [allIds, setAllIds] = useState<string[]>([])

  const enter = useCallback(() => setActive(true), [])
  const exit = useCallback(() => {
    setActive(false)
    setIds(new Set())
  }, [])
  const toggle = useCallback((id: string) => {
    setIds((prev) => {
      const next = new Set(prev)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      return next
    })
  }, [])
  const toggleAll = useCallback(() => {
    setIds((prev) => (prev.size === allIds.length ? new Set() : new Set(allIds)))
  }, [allIds])
  // 内容相等时跳过 setState:避免 allIds 引用抖动 → toggleAll 重建 → 调用方 effect 循环
  const registerAll = useCallback((next: string[]) => {
    setAllIds((prev) =>
      prev.length === next.length && prev.every((id, i) => id === next[i]) ? prev : next,
    )
  }, [])

  return {
    active,
    ids,
    count: ids.size,
    allSelected: allIds.length > 0 && ids.size === allIds.length,
    enter,
    exit,
    toggle,
    toggleAll,
    registerAll,
  }
}
